import Home from '../pages/Home'
import Login from '../pages/panel/Login'
import Zapoi from '../pages/Zapoi'
import Narkomania from '../pages/Narkomania'
import Alcogolizm from '../pages/Alcogolizm'
import Kodirovanie from '../pages/Kodirovanie'
import About from '../pages/About'
import Narcologist from '../pages/Narcologist'
import Article from '../pages/Article/Page'
import ArticleTemplate from '../pages/Article/Template'


const routes = [
  { path: '/', component: Home },
  { path: '/panel/home', component: Home, meta: { title: 'Авторизация' } },
  { path: '/login', component: Login },
  { path: '/zapoi', component: Zapoi },
  { path: '/narkomania', component: Narkomania },
  { path: '/alcogolizm', component: Alcogolizm },
  { path: '/kodirovanie', component: Kodirovanie },
  { path: '/about', component: About },
  { path: '/narcologist', component: Narcologist },
  { path: '/article' , component: Article},
  { path: '/article/:page' , component: ArticleTemplate, props: true},

]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js